module.exports = __webpack_public_path__ + "img/tv.a478228d.png";